import { render } from "./App.vue?vue&type=template&id=2a031c21"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2a031c21&lang=css"

import exportComponent from "C:\\Users\\robyn\\Documents\\RadSystems\\PHPRad VUE Projects\\crm-1.5.4\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__